import { currentOrderedPaidProductLevels } from 'pricing-pages-ui-components/constants/ProductLevel';
import { resolveTierMonthlyPrice } from 'pricing-pages-ui-components/price/tierPricing';
export function getFscTierOptions(productsByTier, term) {
  if (!productsByTier) return [];
  return currentOrderedPaidProductLevels.flatMap(tier => {
    const product = productsByTier[tier];
    if (!(product !== null && product !== void 0 && product.productApiName)) return [];
    return [{
      tier,
      apiName: product.productApiName,
      pricePerSeat: resolveTierMonthlyPrice(product.pricing, term)
    }];
  });
}